<template>
  <section class="suggestion-details">
    <base-card-v2 class="section" :class="{ 'suggestion-details--not-approval': !getHasCampaignApproval }">
      <div v-show="!loadingSuggestionsDetail && !isEditMode" class="suggestion-details__title">
        <base-card-header :title="$t('360.campaigns.details.new')" svg="Oto"></base-card-header>
      </div>
      <campaigns-management-details-group v-show="!loadingSuggestionsDetail" :loading="loadingSuggestionsDetail" />
      <base-loader v-if="loadingSuggestionsDetail" />
    </base-card-v2>
    <!-- suggestion modal dialogs -->
    <campaigns-management-dialog-error-modal />
  </section>
</template>

<script>
// libs
import { useToast } from 'vue-toastification';
import { mapActions, mapState, mapGetters } from 'vuex';

// helpers
import bus from '@/helpers/events/bus';
// components - organisms
import CampaignsManagementDetailsGroup from '@/components/oto/campaignsManagement/_organisms/CampaignsManagementDetailsGroup';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner';
// base modals - ex: success, error
import CampaignsManagementDialogErrorModal from '@/components/oto/campaignsManagement/modals/CampaignsManagementDialogErrorModal';

export default {
  name: 'SuggestionDetail',
  components: {
    CampaignsManagementDetailsGroup,
    CampaignsManagementDialogErrorModal,
    BaseLoader,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  setup() {
    const toast = useToast();

    return { toast };
  },
  computed: {
    ...mapState('campaignsManagement', ['loadingSuggestionsDetail', 'showToastSuccess', 'suggestionDetail']),
    ...mapGetters(['getHasCampaignApproval', 'getWorkingTime']),

    isEditMode() {
      return this.mode === 'edit';
    },
  },
  watch: {
    showToastSuccess() {
      if (this.showToastSuccess) this.showToast();
    },
    mode() {
      this.setMode(this.mode);
    },
  },
  beforeMount() {
    this.setMode(this.mode);
  },
  mounted() {
    if (this.isEditMode) this.setActionId(this.id);

    this.setAutomaticAction({ name: 'startHour', value: this.getWorkingTime?.start || '9:00' });
    this.setAutomaticAction({ name: 'endHour', value: this.getWorkingTime?.end || '18:00' });

    bus.$on('suggestion-trigger-reload', ({ id }) => {
      this.setActionId(id);
    });
  },
  beforeUnmount() {
    this.resetData();
    this.resetAutomaticAction();
  },
  methods: {
    ...mapActions('campaignsManagement', [
      'setMode',
      'setActionId',
      'resetData',
      'resetAutomaticAction',
      'setAutomaticAction',
    ]),
    showToast() {
      const text = this.isEditMode ? this.$t('360.campaigns.toast.updated') : this.$t('360.campaigns.toast.created');
      this.toast.success(text);

      setTimeout(() => {
        this.toast.clear();
      }, 2000);
    },
  },
};
</script>

<style lang="scss">
.suggestion-details {
  &--not-approval {
    border-radius: 0 !important;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .section {
    min-height: 800px;
  }

  hr {
    margin-left: -50px;
    width: calc(100% + 100px);
  }
}
</style>
